export default function(o, sequenceMarker){

  var project = sequenceMarker.roll.split('-')[0]
  var roll = sequenceMarker.roll.split('-')[1]

  var infoText = `${sequenceMarker.en} / project ${project} / roll ${roll} / ${sequenceMarker.start}`

  return infoText

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/util/getMarkerInfoText/getMarkerInfoText.js